import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  ModalCloseButton,
  Text,
  IconButton,
  HStack,
  VStack,
  Button,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  useBreakpointValue,
} from "@chakra-ui/react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { ChevronLeftIcon, ChevronRightIcon, ChevronDownIcon } from "@chakra-ui/icons";

// Fotos locales (asegúrate de que las rutas sean correctas para tu proyecto)
import cuzco1 from "../../media/fotos/mapa/Cuzco.png";
import cuzco2 from "../../media/fotos/mapa/Cuzco-mercado.png";
import cuzco3 from "../../media/fotos/mapa/Cuzco-tejados.png";
import laquiaca from "../../media/fotos/mapa/La-Quiaca.JPG";
import NOA1 from "../../media/fotos/mapa/NOA-Cuesta-de-Lipan-4170-M.png";
import NOA2 from "../../media/fotos/mapa/NOA-Quebrada-de-las-Conchas-2.jpg";
import NOA3 from "../../media/fotos/mapa/NOA-Quebrada-de-las-Conchas.jpg";
import NOA4 from "../../media/fotos/mapa/NOA-furgoneta.png";
import nepal from "../../media/fotos/mapa/Nepal.jpg";
import tailandia from "../../media/fotos/mapa/Tailandia.jpg";
import tropicoCapricornio from "../../media/fotos/mapa/Tropico-de-Capricornio.jpg";
import turquia from "../../media/fotos/mapa/Turquia.jpg";
import bolivia from "../../media/fotos/mapa/Bolivia.jpg";
import jujuy from "../../media/fotos/mapa/Jujuy.jpg";
import cuestalipan from "../../media/fotos/mapa/Lipan-Argentina.jpg";
import puntadeleste from "../../media/fotos/mapa/en-Punta-del-Este-Uruguay.png";
import praiadocassino from "../../media/fotos/mapa/en-Brasil.png";
import cabosanvicente from "../../media/fotos/mapa/cabo_san_vicente.jpg";
import barbatebici from "../../media/fotos/mapa/barbate.jpeg";
import machupicchu from "../../media/fotos/mapa/machupichu.jpg";
import triglav from "../../media/fotos/mapa/triglav.jpg";
import triglavCaravana from "../../media/fotos/mapa/triglav_caravana.jpg";
import fez from "../../media/fotos/mapa/fez_marruecos.jpg";
import meknes from "../../media/fotos/mapa/meknes_marruecos.jpg";
import sierra_cadiz from "../../media/fotos/mapa/furgo_sierra_cadiz.jpg";
import pantano_palo from "../../media/fotos/mapa/pantano_campo_mayor.jpg";
import pantano from "../../media/fotos/mapa/pantano_campo_mayor_yo.jpg";
import jaisalmer from "../../media/fotos/mapa/jaisalmer.jpg";
import pattaya from "../../media/fotos/mapa/pataya.jpg";
import pattaya2 from "../../media/fotos/mapa/pataya_2.jpg";
import udaipur from "../../media/fotos/mapa/udaipur.jpg";
import udaipur2 from "../../media/fotos/mapa/udaipur_2.jpg";
import udaipur3 from "../../media/fotos/mapa/udaipur_3.jpg";
import benares from "../../media/fotos/mapa/benares.jpg";
import benares2 from "../../media/fotos/mapa/benares_2.jpg";

import erfoud from "../../media/fotos/mapa/marruecos_erfoud.JPG";
import erfoud2 from "../../media/fotos/mapa/marruecos_erfoud_2.JPG";
import gargantadades from "../../media/fotos/mapa/marruecos_garganta_dades.JPG";
import imilchil from "../../media/fotos/mapa/marruecos_imilchil.JPG";
import merzouga from "../../media/fotos/mapa/marruecos_merzouga.JPG";
import merzouga2 from "../../media/fotos/mapa/marruecos_merzouga_2.JPG";

import turquia_antalia_1 from "../../media/fotos/mapa/turquia_antala.jpg";
import turquia_antalia_2 from "../../media/fotos/mapa/turquia_antala_2.jpg";
import turquia_antalia_3 from "../../media/fotos/mapa/turquia_antala_3.jpg";
import turquia_antalia_4 from "../../media/fotos/mapa/turquia_antala_4.jpg";

import turquia_fethiye_1 from "../../media/fotos/mapa/turquia_fethiye.jpg";
import turquia_fethiye_2 from "../../media/fotos/mapa/turquia_fethiye_2.jpg";
import turquia_fethiye_3 from "../../media/fotos/mapa/turquia_fethiye_3.jpg";
import turquia_fethiye_4 from "../../media/fotos/mapa/turquia_fethiye_4.jpg";

import turquia_pamukkale_1 from "../../media/fotos/mapa/turquia_pamukale.jpg";
import turquia_pamukkale_2 from "../../media/fotos/mapa/turquia_pamukale_2.jpg";

import turquia_goreme_1 from "../../media/fotos/mapa/turquina_goreme.jpg";
import turquia_goreme_2 from "../../media/fotos/mapa/turquina_goreme_2.jpg";
import turquia_goreme_3 from "../../media/fotos/mapa/turquina_goreme_3.jpg";
import turquia_goreme_4 from "../../media/fotos/mapa/turquina_goreme_4.jpg";
import turquia_goreme_5 from "../../media/fotos/mapa/turquina_goreme_5.jpg";
import turquia_goreme_6 from "../../media/fotos/mapa/turquina_goreme_6.jpg";
import turquia_goreme_7 from "../../media/fotos/mapa/turquina_goreme_7.jpg";
import turquia_goreme_8 from "../../media/fotos/mapa/turquina_goreme_8.jpg";

import chile_santiago_1 from "../../media/fotos/mapa/chile_santiago.jpg";
import chile_santiago_2 from "../../media/fotos/mapa/chile_santiago_2.jpg";
import chile_valparaiso_1 from "../../media/fotos/mapa/chile_valparaiso.jpg";
import chile_valparaiso_2 from "../../media/fotos/mapa/chile_valparaiso_2.jpg";
import chile_valparaiso_3 from "../../media/fotos/mapa/chile_valparaiso_3.jpg";

import el_palmar_1 from "../../media/fotos/mapa/argentina_el_palmar.JPG";
import el_palmar_2 from "../../media/fotos/mapa/argentina_el_palmar_2.JPG";

import guale from "../../media/fotos/mapa/argentina_gualeguaychu.JPG";
import guale_2 from "../../media/fotos/mapa/argentina_gualeguaychu_2.JPG";

import misiones from "../../media/fotos/mapa/argentina_misiones.JPG";
import misiones_2 from "../../media/fotos/mapa/argentina_misiones_2.JPG";

import brasil_iguazu from "../../media/fotos/mapa/brasil_parque_nacional_iguazu.JPG";
import brasil_iguazu_2 from "../../media/fotos/mapa/brasil_parque_nacional_iguazu_2.JPG";
import brasil_iguazu_3 from "../../media/fotos/mapa/brasil_parque_nacional_iguazu_3.JPG";
import brasil_iguazu_4 from "../../media/fotos/mapa/brasil_parque_nacional_iguazu_4.JPG";

import paraguay from "../../media/fotos/mapa/paraguay_ciudad_del_este.JPG";
import paraguay_2 from "../../media/fotos/mapa/paraguay_ciudad_del_este_2.JPG";

import argentina_iguazu from "../../media/fotos/mapa/argentina_cataratas_iguazu.JPG";
import argentina_iguazu_2 from "../../media/fotos/mapa/argentina_cataratas_iguazu_2.JPG";
import argentina_iguazu_3 from "../../media/fotos/mapa/argentina_cataratas_iguazu_3.JPG";

import burgos_1 from "../../media/fotos/mapa/burgos_1.JPG";
import burgos_2 from "../../media/fotos/mapa/burgos_2.JPG";

import canarias_1 from "../../media/fotos/mapa/canarias_1.JPG";
import canarias_2 from "../../media/fotos/mapa/canarias_2.JPG";

import noja_1 from "../../media/fotos/mapa/noja_1.JPG";
import noja_2 from "../../media/fotos/mapa/noja_2.JPG";

import sierra_nevada from "../../media/fotos/mapa/sierra_nevada.jpg";

import valencia from "../../media/fotos/mapa/valencia.JPG";

import gibraltar from "../../media/fotos/mapa/gibraltar.JPG";

import andorra_la_bella from "../../media/fotos/mapa/andorra.JPG";

import montpellier_1 from "../../media/fotos/mapa/montpellier_1.JPG";
import montpellier_2 from "../../media/fotos/mapa/montpellier_2.JPG";
import montpellier_3 from "../../media/fotos/mapa/montpellier_3.JPG";
import montpellier_4 from "../../media/fotos/mapa/montpellier_4.JPG";

import ensues_1 from "../../media/fotos/mapa/ensues_la_redonne_1.JPG"
import ensues_2 from "../../media/fotos/mapa/ensues_la_redonne_2.JPG"
import ensues_3 from "../../media/fotos/mapa/ensues_la_redonne_3.JPG"

import marsella_1 from "../../media/fotos/mapa/marsella_1.JPG"
import marsella_2 from "../../media/fotos/mapa/marsella_2.JPG"
import marsella_3 from "../../media/fotos/mapa/marsella_3.JPG"

import mandelieu_la_napoule from "../../media/fotos/mapa/mandelieu_la_napoule.JPG"

import niza_1 from "../../media/fotos/mapa/niza_1.JPG"
import niza_2 from "../../media/fotos/mapa/niza_2.JPG"

import paris_1 from "../../media/fotos/mapa/paris_1.JPG"
import paris_2 from "../../media/fotos/mapa/paris_2.JPG"
import paris_3 from "../../media/fotos/mapa/paris_3.JPG"
import paris_4 from "../../media/fotos/mapa/paris_4.JPG"
import paris_5 from "../../media/fotos/mapa/paris_5.JPG"
import paris_6 from "../../media/fotos/mapa/paris_6.JPG"

import monaco from "../../media/fotos/mapa/monaco.JPG"

import ventimiglia from "../../media/fotos/mapa/ventimiglia_1.JPG"
import cinqueterre_1 from "../../media/fotos/mapa/CinqueTerre_1.JPG"
import cinqueterre_2 from "../../media/fotos/mapa/CinqueTerre_2.JPG"
import cinqueterre_3 from "../../media/fotos/mapa/CinqueTerre_3.JPG"
import cinqueterre_4 from "../../media/fotos/mapa/CinqueTerre_4.JPG"
import cinqueterre_5 from "../../media/fotos/mapa/CinqueTerre_5.JPG"

import pisa_1 from "../../media/fotos/mapa/Pisa_1.jpg"
import pisa_2 from "../../media/fotos/mapa/Pisa_2.jpg"
import pisa_3 from "../../media/fotos/mapa/Pisa_3.jpg"

import follonica from "../../media/fotos/mapa/follonica_1.JPG"

import roma_1 from "../../media/fotos/mapa/roma_1.JPG"
import roma_2 from "../../media/fotos/mapa/roma_2.JPG"
import roma_3 from "../../media/fotos/mapa/roma_3.JPG"

import sirolo from "../../media/fotos/mapa/sirolo_1.JPG"

import fusina from "../../media/fotos/mapa/fusina_1.JPG"

import venecia_1 from "../../media/fotos/mapa/venecia_1.JPG"
import venecia_2 from "../../media/fotos/mapa/venecia_2.JPG"
import venecia_3 from "../../media/fotos/mapa/venecia_3.JPG"




export function Mapa() {
  const mapRef = useRef();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [currentPhotoIndex, setCurrentPhotoIndex] = useState(0);

  // Colores por continente
  const continentColors = {
    Africa: "#ffc002ff",
    America: "#229413ff",
    Asia: "#f90505ff",
    Europa: "#ec0ecbff",
  };

  // Crear iconos personalizados
  const createColoredIcon = (color) => {
    return L.divIcon({
      className: "custom-marker",
      html: `<div style="
        width: 16px;
        height: 16px;
        background-color: ${color};
        border: 3px solid white;
        border-radius: 50%;
        box-shadow: 0 2px 8px rgba(0,0,0,0.3);
        cursor: pointer;
        transition: transform 0.2s ease;
      "></div>`,
      iconSize: [16, 16],
      iconAnchor: [8, 8],
    });
  };

  // Configuración de zoom por continente
  const continentViews = {
    Africa: { center: [0, 20], zoom: 3 },
    America: { center: [-15, -60], zoom: 3 },
    Asia: { center: [25, 100], zoom: 3 },
    Europa: { center: [50, 10], zoom: 4 },
  };

  const openModal = (location) => {
    setSelectedLocation(location);
    setCurrentPhotoIndex(0);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedLocation(null);
    setCurrentPhotoIndex(0);
  };

  const prevPhoto = () => {
    if (!selectedLocation) return;
    setCurrentPhotoIndex((prev) =>
      prev === 0 ? selectedLocation.images.length - 1 : prev - 1
    );
  };

  const nextPhoto = () => {
    if (!selectedLocation) return;
    setCurrentPhotoIndex((prev) =>
      prev === selectedLocation.images.length - 1 ? 0 : prev + 1
    );
  };

  // Función para hacer zoom a un continente
  const zoomToContinent = (continent) => {
    if (mapRef.current && continentViews[continent]) {
      const { center, zoom } = continentViews[continent];
      mapRef.current.setView(center, zoom, { animate: true });
    }
  };

  // Función para hacer zoom a una ubicación específica
  const zoomToLocation = (location) => {
    if (mapRef.current) {
      mapRef.current.setView(location.position, 8, { animate: true });
    }
  };

  const ubicaciones = [
    { position: [-13.531379, -71.9676065], title: "Cuzco (Perú)", description: "Recorriendo la Ruta Inca año 2010", images: [cuzco1, cuzco2, cuzco3], continent: "America" },
    { position: [-22.107787, -65.6723249], title: "La Quiaca (Argentina)", description: "Recorriendo el norte de Argentina año 2012", images: [laquiaca], continent: "America" },
    { position: [-26.0086133, -65.8161651], title: "Quebrada de las Conchas (Argentina)", description: "Recorriendo el norte de Argentina año 2012", images: [NOA1, NOA2, NOA3, NOA4], continent: "America" },
    { position: [27.7089542, 85.2848476], title: "Katmandú (Nepal)", description: "Viajando por India, Nepal y Tailandia año 2006", images: [nepal], continent: "Asia" },
    { position: [9.7349672, 99.9799198], title: "Ko Pha Ngan (Tailandia)", description: "Viajando por India, Nepal y Tailandia año 2006", images: [tailandia], continent: "Asia" },
    { position: [-23.2096052, -65.3612742], title: "Trópico de Capricornio (Argentina)", description: "Humahuaca, recorriendo el norte de Argentina año 2012", images: [tropicoCapricornio], continent: "America" },
    { position: [38.3694873, 33.7453962], title: "Capadocia (Turquía)", description: "Recorriendo Turquía año 2011", images: [turquia], continent: "Asia" },
    { position: [-22.0834239, -65.6242241], title: "Villazón (Bolivia)", description: "Cambiando de países para renovar visado año 2012", images: [bolivia], continent: "America" },
    { position: [-24.4986758, -65.3094154], title: "Jujuy (Argentina)", description: "Recorriendo el norte de Argentina año 2012", images: [jujuy], continent: "America" },
    { position: [-23.6855512, -65.6579762], title: "Cuesta de Lipán (Argentina)", description: "Recorriendo el norte de Argentina año 2012", images: [cuestalipan], continent: "America" },
    { position: [-34.9427003, -54.9521067], title: "Punta del Este (Uruguay)", description: "Cambiando de países para renovar visado año 2012", images: [puntadeleste], continent: "America" },
    { position: [-32.1870643, -52.1846751], title: "Praia do Cassino (Brasil)", description: "Visitando la playa más extensa del mundo año 2010", images: [praiadocassino], continent: "America" },
    { position: [37.0233323, -9.0047656], title: "Cabo de San Vicente (Portugal)", description: "Recorriendo el sur de Portugal en bici año 2015", images: [cabosanvicente], continent: "Europa" },
    { position: [36.1902048, -5.9251113], title: "Barbate (España)", description: "Viviendo en el paraíso de Barbate", images: [barbatebici], continent: "Europa" },
    { position: [-13.1631981, -72.5637159], title: "Machu Picchu (Perú)", description: "Recorriendo la Ruta Inca año 2010", images: [machupicchu], continent: "America" },
    { position: [46.3424727, 13.7964685], title: "Parque Nacional del Triglav (Eslovenia)", description: "Recorriendo Europa la primera vez con la caravana", images: [triglav, triglavCaravana], continent: "Europa" },
    { position: [34.0239383, -5.0796784], title: "Fez (Marruecos)", description: "Recorriendo 1000 kms en bicicleta por Marruecos", images: [fez], continent: "Africa" },
    { position: [33.8809776, -5.6204199], title: "Meknes (Marruecos)", description: "Estos chicos nos invitaron a desayunar dulces y café recién hecho", images: [meknes], continent: "Africa" },
    { position: [36.8398419, -5.3940783], title: "Recorriendo la sierra de Cádiz (España)", description: "Viajando en furgoneta por los alrededores de Zahara de la Sierra", images: [sierra_cadiz], continent: "Europa" },
    { position: [39.0319263, -7.2702674], title: "Pantano de Campo Mayor (Portugal)", description: "Echando en rato con Palito", images: [pantano, pantano_palo], continent: "Europa" },
    { position: [26.9035728, 70.8535309], title: "Desierto Jaisalmer (India)", description: "Varios días recorriendo en desierto y durmiendo a la interperie", images: [jaisalmer], continent: "Asia" },
    { position: [12.8866953, 100.9227597], title: "Pattaya (Tailandia)", description: "Explorando playas de Pattaya", images: [pattaya, pattaya2], continent: "Asia" },
    { position: [24.6082638, 73.6224722], title: "Udaipur en Rajastán (India)", description: "Uno de los lugares que me enamoró de India", images: [udaipur, udaipur2, udaipur3], continent: "Asia" },
    { position: [25.3207397, 82.908709], title: "Benarés (India)", description: "El Ganges, considerado diosa viviente en India", images: [benares, benares2], continent: "Asia" },
    { position: [31.4667081, -4.4253896], title: "Erfoud (Marruecos)", description: "Desierto del Sahara", images: [erfoud, erfoud2], continent: "Africa" },
    { position: [31.4477686, -7.137458], title: "Garganta del Dades (Marruecos)", description: "Carretera serpenteante con paredes empinadas", images: [gargantadades], continent: "Africa" },
    { position: [32.1550861, -5.6396985], title: "Imilchil (Marruecos)", description: "Comuna rural situada en el Medio Atlas", images: [imilchil], continent: "Africa" },
    { position: [31.0812101, -4.0349378], title: "Merzouga (Marruecos)", description: "Desierto del Sahara", images: [merzouga, merzouga2], continent: "Africa" },
    { position: [36.8978237, 30.5533015], title: "Antalya (Turquía)", description: "Zona de costa preciosa en la provincia de Antalya", images: [turquia_antalia_1, turquia_antalia_2, turquia_antalia_3, turquia_antalia_4], continent: "Asia" },
    { position: [36.6517916, 29.0394704], title: "Fethiye (Turquía)", description: "En la provincia de Muğla", images: [turquia_fethiye_1, turquia_fethiye_2, turquia_fethiye_3, turquia_fethiye_4], continent: "Asia" },
    { position: [37.9152806, 29.1068713], title: "Pamukkale (Turquía)", description: "Conocida por sus aguas termales", images: [turquia_pamukkale_1, turquia_pamukkale_2], continent: "Asia" },
    { position: [38.6430536, 34.8082895], title: "Goreme (Turquía)", description: "En la región de Capadocia en Anatolia central", images: [turquia_goreme_1, turquia_goreme_2, turquia_goreme_3, turquia_goreme_4, turquia_goreme_5, turquia_goreme_6, turquia_goreme_7, turquia_goreme_8], continent: "Asia" },
    { position: [-33.4723517, -70.9594572], title: "Santiago (Chile)", description: "Capital de Chile, rodeada de cimas nevadas", images: [chile_santiago_1, chile_santiago_2], continent: "America" },
    { position: [-33.0501734, -71.6934483], title: "Valparaíso (Chile)", description: "Valparaíso es una ciudad portuaria de la costa de Chile", images: [chile_valparaiso_1, chile_valparaiso_2, chile_valparaiso_3], continent: "America" },
    { position: [-31.8543081, -58.3297092], title: "El Palmar (Argentina)", description: "Parque Nacional de Argentina", images: [el_palmar_1, el_palmar_2], continent: "America" },
    { position: [-33.0080671, -58.7128931], title: "Gualeguaychú (Argentina)", description: "Ciudad fronteriza, la usaba para renovar el visado", images: [guale, guale_2], continent: "America" },
    { position: [-26.8057303, -57.4820588], title: "Misiones (Argentina)", description: "Provincia de misiones, espectacular la zona", images: [misiones, misiones_2], continent: "America" },
    { position: [-25.6333244, -54.6233952], title: "Cataratas de Iguazú (Brasil)", description: "Parque Nacional Iguazú", images: [brasil_iguazu, brasil_iguazu_2, brasil_iguazu_3, brasil_iguazu_4], continent: "America" },
    { position: [-25.4933149, -54.8361312], title: "Ciudad del Este (Paraguay)", description: "Junto al río Paraná", images: [paraguay, paraguay_2], continent: "America" },
    { position: [-25.5658407, -55.4524908], title: "Cataratas de Iguazú (Argentina)", description: "Parque Nacional Iguazú", images: [argentina_iguazu, argentina_iguazu_2, argentina_iguazu_3], continent: "America" },
    { position: [42.340864, -3.7070298], title: "Catedral de Burgos 2005 (España)", description: "Casco Histórico de Burgos", images: [burgos_1, burgos_2], continent: "Europa" },
    { position: [28.1173546, -15.4808164], title: "Las Palmas de Gran Canaria 2006 (España)", description: "Recorriendo Las Palmas de Gran Canaria", images: [canarias_1, canarias_2], continent: "Europa" },
    { position: [43.4792748, -3.5531957], title: "Noja en Cantabría 2005 (España)", description: "Día de playa y skate con gente nueva", images: [noja_1, noja_2], continent: "Europa" },
    { position: [37.0952242, -3.3970986], title: "Sierra Nevada en Granada 2004 (España)", description: "Fin de semana de mucha nieve", images: [sierra_nevada], continent: "Europa" },
    { position: [39.4744494, -0.443493], title: "Valencia 2005 (España)", description: "Fin de semana de Fallas", images: [valencia], continent: "Europa" },
    { position: [36.1295075, -5.3738995], title: "Gibraltar 2010 (España)", description: "Vistas desde Gibraltar", images: [gibraltar], continent: "Europa" },
    { position: [42.5050846, 1.5100658], title: "Andorra la Vella 2010 (Andorra)", description: "Vistas desde Andorra la Vella", images: [andorra_la_bella], continent: "Europa" },
    { position: [43.6099786, 3.79177], title: "Montpellier 2010 (Francia)", description: "Paseando por Montpellier y comiendo en el coche", images: [montpellier_1, montpellier_2, montpellier_3, montpellier_4], continent: "Europa" },
    { position: [43.3553889, 5.1880428], title: "Ensues la Redonne (Francia)", description: "Enredando por el puerto", images: [ensues_1, ensues_2, ensues_3], continent: "Europa" },
    { position: [43.2798658, 5.0510171], title: "Marsella 2010 (Francia)", description: "Paseando por Marsella", images: [marsella_1, marsella_2, marsella_3], continent: "Europa" },
    { position: [43.5333529,6.8355801], title: "Mandelieu la Napoule 2010 (Francia)", description: "Paseando por Mandelieu la Napoule", images: [mandelieu_la_napoule], continent: "Europa" },
    { position: [43.7031655,7.1702409], title: "Niza 2010 (Francia)", description: "Cocinando un arroz con verduras en el paseo de Niza", images: [niza_1, niza_2], continent: "Europa" },
    { position: [48.8583701,2.291901], title: "París 2010 (Francia)", description: "Paseando por la capital y las vistas de la Torre Eiffel", images: [paris_1, paris_2, paris_3, paris_4, paris_5, paris_6], continent: "Europa" },
    { position: [43.7378495,7.40521], title: "Mónaco 2010 (Francia)", description: "Lo mejor de Mónaco el azul del agua", images: [monaco], continent: "Europa" },
    { position: [43.7996319,7.5669529], title: "Ventimiglia 2010 (Italia)", description: "Comenzando a recorrer la bota", images: [ventimiglia], continent: "Europa" },
    { position: [44.1237302,9.6087747], title: "Cinque Terre 2010 (Italia)", description: "ESPECTACULAR!", images: [cinqueterre_1, cinqueterre_2, cinqueterre_3, cinqueterre_4, cinqueterre_5], continent: "Europa" },
    { position: [43.722952,10.3940167], title: "Pisa 2010 (Italia)", description: "Esa torre cualquier día se cae...", images: [pisa_1, pisa_2, pisa_3], continent: "Europa" },
    { position: [42.9283837,10.6675819], title: "Follonica 2010 (Italia)", description: "En la provincia de Grosseto", images: [follonica], continent: "Europa" },
    { position: [41.9095978,12.2056898], title: "Roma 2010 (Italia)", description: "Demasiado calor y romano...", images: [roma_1, roma_2, roma_3], continent: "Europa" },
    { position: [43.3649905,13.6075457], title: "Sirolo 2010 (Italia)", description: "Etapa previa al salto a Grecia", images: [sirolo], continent: "Europa" },
    { position: [45.4195555,12.2518124], title: "Fusina 2010 (Italia)", description: "Etapa previa al salto a Grecia", images: [fusina], continent: "Europa" },
    { position: [45.4040672,12.0570269], title: "Venecia 2010 (Italia)", description: "Qué buena mesa.", images: [venecia_1, venecia_2, venecia_3], continent: "Europa" },
  ];

  // Agrupar ubicaciones por continente y ordenar alfabéticamente
  const ubicacionesPorContinente = ubicaciones.reduce((acc, ubicacion) => {
    if (!acc[ubicacion.continent]) {
      acc[ubicacion.continent] = [];
    }
    acc[ubicacion.continent].push(ubicacion);
    return acc;
  }, {});
  Object.keys(ubicacionesPorContinente).forEach((continent) => {
    ubicacionesPorContinente[continent].sort((a, b) =>
      a.title.localeCompare(b.title, "es", { numeric: true })
    );
  });

  // Adaptar el layout del menú para móviles
  const menuLayout = useBreakpointValue({ base: "column", md: "row" });

  useEffect(() => {
    const timer = setTimeout(() => {
      if (mapRef.current) {
        mapRef.current.invalidateSize();
      }
    }, 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <Box display="flex" justifyContent="center" w="100%" p={2}>
      <VStack spacing={4} w="100%" maxW="1200px">
        {/* Menú por continentes */}
        <VStack spacing={2} w="100%">
          {Object.keys(continentViews).map((continent) => (
            <Menu key={continent}>
              <MenuButton
                as={Button}
                rightIcon={<ChevronDownIcon />}
                onClick={() => zoomToContinent(continent)}
                colorScheme="blue"
                variant="outline"
                _hover={{ bg: "blue.50" }}
                w="100%"
                leftIcon={
                  <Box
                    w={3}
                    h={3}
                    borderRadius="50%"
                    bg={continentColors[continent]}
                  />
                }
              >
                {continent}
              </MenuButton>
              <MenuList maxH="300px" overflowY="auto" w="100%">
                {ubicacionesPorContinente[continent]?.map((ubicacion, index) => (
                  <MenuItem
                    key={index}
                    onClick={() => {
                      zoomToLocation(ubicacion);
                      openModal(ubicacion);
                    }}
                    _hover={{ bg: "blue.50", color: continentColors[continent]}}
                    icon={
                      <Box
                        w={2}
                        h={2}
                        borderRadius="50%"
                        bg={continentColors[continent]}
                      />
                    }
                  >
                    <Box>
                      <Text fontWeight="semibold" fontSize="sm">
                        {ubicacion.title}
                      </Text>
                      <Text fontSize="xs" color="gray.500" noOfLines={1}>
                        {ubicacion.description}
                      </Text>
                    </Box>
                  </MenuItem>
                ))}
              </MenuList>
            </Menu>
          ))}
        </VStack>

        

        {/* Mapa */}
        <Box
          w={{ base: "100%", lg: "90vw" }}   // En escritorio más ancho
          h={{ base: "400px", md: "600px", lg: "70vh" }} // Altura adaptable
          borderRadius="lg"
          overflow="hidden"
          boxShadow="2xl"
          border="2px solid"
          borderColor="blue.200"
        >
          <MapContainer
            center={[0, 0]}
            zoom={2}
            style={{ width: "100%", height: "100%" }}
            whenCreated={(mapInstance) => {
              mapRef.current = mapInstance;
              setTimeout(() => mapInstance.invalidateSize(), 200);
            }}
            scrollWheelZoom={true}
          >
            <TileLayer
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
            />

            {ubicaciones.map((item, index) => {
              const color = continentColors[item.continent] || "#666";
              return (
                <Marker
                  key={index}
                  position={item.position}
                  icon={createColoredIcon(color)}
                  eventHandlers={{
                    click: () => openModal(item),
                  }}
                >
                  <Popup>
                    <Box textAlign="center">
                      <Text fontWeight="bold">{item.title}</Text>
                      <Text fontSize="sm">{item.description}</Text>
                    </Box>
                  </Popup>
                </Marker>
              );
            })}
          </MapContainer>
        </Box>

        {/* <Text fontSize="small" textAlign="center" textColor="orange">
          Hace años dejé de viajar, está todo infectado de gente. ¡Qué pereza!
        </Text> */}
        <Box p={10}></Box> 
      </VStack>

      {/* Modal con carrusel */}
      <Modal isOpen={isModalOpen} onClose={closeModal} size="full" isCentered>
        <ModalOverlay bg="blackAlpha.800" />
        <ModalContent bg="transparent" shadow="none" maxW="95vw" maxH="95vh" p={1}>
          <ModalCloseButton
            color="white"
            size="lg"
            bg="blackAlpha.600"
            _hover={{ bg: "blackAlpha.800" }}
            zIndex={20}
            pointerEvents="auto"
          />
          <ModalBody p={0} display="flex" justifyContent="center" alignItems="center" flexDirection="column">
            {selectedLocation && (
              <Box textAlign="center" position="relative" w="100%">
                <img
                  src={selectedLocation.images[currentPhotoIndex]}
                  alt={selectedLocation.title}
                  style={{
                    width: "100%",
                    maxHeight: "75vh",
                    objectFit: "contain",
                    borderRadius: "12px",
                  }}
                />

                <Box bg="blackAlpha.700" color="white" p={4} mt={2} borderRadius="md">
                  <Text fontSize={{ base: "md", md: "xl" }} fontWeight="bold" mb={1}>
                    {selectedLocation.title}
                  </Text>
                  <Text fontSize={{ base: "sm", md: "md" }}>{selectedLocation.description}</Text>
                </Box>

                {selectedLocation.images.length > 1 && (
                  <HStack
                    position="absolute"
                    top="50%"
                    left="0"
                    right="0"
                    justifyContent="space-between"
                    px={2}
                    transform="translateY(-50%)"
                    zIndex={10}
                  >
                    <IconButton
                      icon={<ChevronLeftIcon />}
                      onClick={prevPhoto}
                      aria-label="Foto anterior"
                      bg="cyan.500"
                      color="white"
                      border="2px solid white"
                      _hover={{ bg: "cyan.400", transform: "scale(1.1)" }}
                      _active={{ bg: "cyan.600" }}
                      size="md"
                      borderRadius="full"
                    />
                    <IconButton
                      icon={<ChevronRightIcon />}
                      onClick={nextPhoto}
                      aria-label="Siguiente foto"
                      bg="cyan.500"
                      color="white"
                      border="2px solid white"
                      _hover={{ bg: "cyan.400", transform: "scale(1.1)" }}
                      _active={{ bg: "cyan.600" }}
                      size="md"
                      borderRadius="full"
                    />
                  </HStack>
                )}
              </Box>
            )}
          </ModalBody>
        </ModalContent>
      </Modal>
    </Box>
  );
}
